/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';
import { SmorgStudioMembership } from '../../API';

export interface SmorgStudioMembershipsState {
  smorgStudioMemberships: Array<SmorgStudioMembership>;
}

const initialState: SmorgStudioMembershipsState = {
  smorgStudioMemberships: [],
};

export const smorgStudioMembershipsSlice = createSlice({
  name: 'smorgStudioMemberships',
  initialState,
  reducers: {
    membershipsAvailable: (
      state,
      action: PayloadAction<{
        memberships: Array<SmorgStudioMembership>;
        offset: number;
      }>,
    ) => {
      const { memberships, offset } = action.payload;
      const newMemberships = (state.smorgStudioMemberships || []).slice(
        0,
        offset || 0,
      );
      newMemberships.push(...memberships);
      state.smorgStudioMemberships = newMemberships;
    },
    membershipUpdated: (
      state,
      action: PayloadAction<SmorgStudioMembership>,
    ) => {
      const smorgStudioMembership = action.payload;
      const index = state.smorgStudioMemberships.findIndex(
        (membership) => membership.id === smorgStudioMembership.id,
      );
      if (index !== -1) {
        state.smorgStudioMemberships[index] = smorgStudioMembership;
      }
    },
    userDeleted: (state, action: PayloadAction<string>) => {
      const spaceMembershipID = action.payload;
      state.smorgStudioMemberships = state.smorgStudioMemberships.filter(
        (membership) => membership.id !== spaceMembershipID,
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.smorgStudioMemberships = [];
    });
  },
});

export const { membershipsAvailable, membershipUpdated, userDeleted } =
  smorgStudioMembershipsSlice.actions;

export default smorgStudioMembershipsSlice.reducer;
